export default {
  welcome: 'Create your shop',
  createShop: 'Create shop',
  shopName: 'Shop name',
  shopNameHint: 'This name is used for your team and shop',
  shopNamePlaceholder: 'e.g. Corner Café',
  creatingShop: 'Creating your shop…',
  step1: 'Creating your team',
  step2: 'Setting up your shop',
  step3: 'Finishing up',
  shopCreated: 'Shop created',
  shopCreatedMessage: 'Redirecting to shop management…',
  errorCreatingShop: 'Could not create the shop. Please try again.',
  loadingSession: 'Checking your session…',
  openingShopManagement: 'Opening shop management…',
  loadingTeams: 'Loading teams…',
  teamInfo: 'Team',
  teamInfoMessage: 'Your shop will be created under "{teamName}".',
  checkingShops: 'Checking existing shops…',
}
